import PropTypes from 'prop-types';
import {Button, Toggle} from '@/components/atoms';
import {TextInputField} from '@/components/molecules';
import {MAX_PEPIRIS_GUIDELINES} from '@/utils/constants/perfectStoreConstants';
import {pepirisGuidelineUiSchema, STRING_SCHEMA} from './schemas';

const PepIrisGuidelinesSection = ({
  enabled,
  guidelines,
  languages,
  toggleSchema,
  toggleId,
  onToggle,
  onChange,
  onAdd,
  onRemove,
  addTestId
}) => (
  <div className='mt-6' data-testid={`${toggleId}-section`}>
    <Toggle
      id={toggleId}
      value={!!enabled}
      updateValue={onToggle}
      uiSchema={toggleSchema}
    />
    {enabled && (
      <div className='mt-4'>
        {guidelines.map((row, index) => (
          <div
            key={row.id}
            className='mb-4'
            data-testid={`${toggleId}-row-${index}`}>
            <div className='multi-language-grid'>
              {languages.map((lang) => {
                const schema = pepirisGuidelineUiSchema(index);
                return (
                  <div key={lang.code} className='multi-language-column'>
                    <TextInputField
                      value={row.content?.[lang.code]?.text || ''}
                      label={schema.label}
                      schema={STRING_SCHEMA}
                      uiSchema={schema}
                      updateValue={(val, hasError) =>
                        onChange(index, lang.code, val, hasError)
                      }
                      visible
                    />
                  </div>
                );
              })}
            </div>
            {index >= 2 && (
              <Button
                id={`${toggleId}-remove-${index}`}
                handleButton={() => onRemove(index)}
                uiSchema={{
                  title: 'Remove',
                  variant: 'tertiary',
                  size: 'small',
                  className: 'mt-2'
                }}
              />
            )}
          </div>
        ))}
        <Button
          id={addTestId}
          handleButton={onAdd}
          uiSchema={{
            title: 'Add Guideline',
            variant: 'tertiary',
            size: 'medium',
            iconLeading: 'add_box',
            className: 'mt-2',
            disabled: guidelines.length >= MAX_PEPIRIS_GUIDELINES
          }}
        />
      </div>
    )}
  </div>
);

PepIrisGuidelinesSection.propTypes = {
  enabled: PropTypes.bool,
  guidelines: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      content: PropTypes.object
    })
  ),
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      title: PropTypes.string
    })
  ).isRequired,
  toggleSchema: PropTypes.object.isRequired,
  toggleId: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  addTestId: PropTypes.string.isRequired
};

export default PepIrisGuidelinesSection;
